import { render, staticRenderFns } from "./handle-cer-bf.vue?vue&type=template&id=81185c54"
import script from "./handle-cer-bf.vue?vue&type=script&lang=js"
export * from "./handle-cer-bf.vue?vue&type=script&lang=js"
import style0 from "./handle-cer-bf.vue?vue&type=style&index=0&id=81185c54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports